<div class="demo">
      <nav class="pagination-outer" aria-label="Page navigation">
          <ul class="pagination">
              <li class="page-item">
                  <a href="#" class="page-link" aria-label="Previous">
                      <span aria-hidden="true">Prev</span>
                  </a>
              </li>
              <li class="page-item"><a class="page-link" href="#">1</a></li>
              <li class="page-item active"><a class="page-link" href="#">2</a></li>
              <li class="page-item"><a class="page-link" href="#">3</a></li>
              <li class="page-item"><a class="page-link" href="#">4</a></li>
              <li class="page-item"><a class="page-link" href="#">5</a></li>
              <li class="page-item">
                  <a href="#" class="page-link" aria-label="Next">
                      <span aria-hidden="true">Next</span>
                  </a>
              </li>
          </ul>
      </nav>
  </div>
